export default __webpack_public_path__ + "static/media/alert-circle-red.16163ee3.svg";